<template>
    <div class="slide-bar" :class="{collapse: collapse}">
        <div class="menu">
            <ul>
                <li class="item" 
                    :class="{expand: item.children && item.children.length > 0,
                    active: curPath.indexOf(routeParent + '/' + item.path) >= 0}"
                    v-for="(item, index) in routesList" :key="index"
                >
                    <div class="text"
                        @click="toRouterView(item)"
                    >
                        <i :class="'icon ' + item.meta.icon"></i> {{item.meta.title}}
                        <i v-if="item.children && item.children.length > 0 && item.childrenShow" 
                            class="icon-arrow"
                            :class="item.expand ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"
                        ></i>
                    </div>
                    <ul class="sub-list" v-if="item.children && item.children.length > 0 && item.expand">
                        <template v-for="(ele, i) in item.children">
                            <li :class="{active: curPath.indexOf(routeParent + '/' + item.path +'/' + ele.path) >= 0}"
                                :key="i"
                                v-if="!ele.meta.hidden"
                            >
                                <div class="sub-text" @click="toRouterView(item, ele)">{{ele.meta.title}}</div>
                            </li>
                        </template>
                    </ul>
                </li>
            </ul>
        </div>
        <div class="toggle" @click="toggleSideBar">
            <i class="toggle-icon" :class="collapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"></i>
            <div class="shape"></div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            routesList: [],
            collapse: false
        }
    },
    watch: {
        routeParent: function() {
            this.routesList = this.routes;
        }
    },
    computed: {
        routeParent() {
            return this.$route.matched[0].path
        },
        curPath() {
            return this.$route.path
        },
        routes() {
            // console.log(this.$router)
            // console.log(this.$route)
            let selectRoutes = this.$router.options.routes.filter(item => {
                if (item.path == this.routeParent) {
                    return true
                } else {
                    return false
                }
            })
            let showRoutes = []
            if (selectRoutes.length > 0) {
                showRoutes = selectRoutes[0].children.filter(item => {
                    return item.meta && !item.meta.hidden
                })
                
                showRoutes = showRoutes.map(item => {
                    let someChildrenShow = false
                    if (item.children && item.children.length > 0) {
                        someChildrenShow = item.children.some(item => !item.meta.hidden);
                    }
                    if (item.children && item.children.length > 0) {
                        
                        if (this.$route.path.indexOf(this.routeParent + '/' + item.path) > -1) {
                            return {
                                ...item,
                                expand: true,
                                childrenShow: someChildrenShow
                            }
                        }
                    } 
                    return {
                        ...item,
                        expand: false,
                        childrenShow: someChildrenShow
                    }
                })
            } 
            // console.log('selectRoutes', showRoutes)
            return showRoutes
        }
    },
    created() {
        this.routesList = this.routes;
        // console.log(this.routes)
        // console.log(this.$route);
        // console.log(this.$router)
    },
    methods: {
        toggleSideBar() {
            this.collapse = !this.collapse
        },
        toRouterView(item, ele) {
            console.log(item, ele)
            if (ele) {
                this.$router.push(this.routeParent + '/' + item.path + '/' + ele.path)
            } else {
                let someChildrenShow = false;
                if (item.children) {
                    someChildrenShow = item.children.some(item => !item.meta.hidden)
                }
                if (item.children && someChildrenShow) {
                    item.expand = !item.expand
                } else {
                    this.$router.push(this.routeParent + '/' + item.path)
                }
            }
            
        }
    }
}
</script>

<style lang="scss" scoped>
.slide-bar {
    float: left;
    width: 180px;
    height: 100%;
    box-sizing: border-box;
    background:rgba(255,255,255,1);
    transition-duration: .2s;
    user-select: none;
    border-right: 1px solid #F7F7F7;
    position: relative;
    z-index: 9;
    &.collapse {
        margin-left: -180px;
    }
}

.menu {
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    .item {
        margin-top: 16px;
        height: 48px;
        line-height: 48px;
        .text {
            cursor: pointer;
            position: relative;
            padding-left: 18px;
            font-size: 14px;
            color: #2A2E3F;
            &:hover {
                background:rgba(199,0,9,0.04);
                color: #F81D22;
                .icon-arrow {
                    color: #F81D22;
                }
            }
        }
        .icon {
            font-size: 18px;
            margin-right: 6px;
        }
        &.expand {
            height: auto;
            .icon-arrow {
                position: absolute;
                right: 18px; top: 0;
                line-height: 48px;
                color: #2A2E3F;
            }
            .sub-list {
                .sub-text {
                    cursor: pointer;
                    padding-left: 54px;
                    font-size: 14px;
                    color: #2A2E3F;
                }
                li:hover {
                    background:rgba(199,0,9,0.04);
                    .sub-text {
                        color: #F81D22;
                    }
                }
                li.active .sub-text {
                    color: #F81D22;
                }
            }
        }
        &.active {
            .text {
                background:rgba(199,0,9,0.04);
                color: #F81D22;
            }
            .icon-arrow {
                color: #F81D22;
            }
        }
    }
}
.toggle {
    position: absolute;
    right: 0; top: 50%;
    z-index: 10;
    width: 20px;
    height: 50px;
    margin-top: -25px;
    overflow: hidden;
    cursor: pointer;
    .toggle-icon {
        position: absolute;
        top: 50%;
        font-size: 16px;
        line-height: 16px;
        height: 16px;
        margin-top: -8px;
        left: 10px;
        color: #444;
        transition-duration: .2s;
    }
    .shape {
        right: 0;
        left: auto;
        height: 50px;
        border-bottom: 9px solid transparent;
        border-left: none;
        border-right: 13px solid #f0f0f0;
        border-top: 9px solid transparent;
        box-sizing: border-box;
        transition-duration: .2s;
    }
    &:hover {
        .toggle-icon {
            left: 3px;
        }
        .shape {
            border-right-width: 20px;
        }
    }
}
.slide-bar.collapse {
    .toggle {
        right: -20px;
        .toggle-icon {
            left: auto; 
            right: 10px;
        }
        .shape {
            left: 0;
            right: auto;
            height: 50px;
            border-bottom: 9px solid transparent;
            border-right: none;
            border-left: 13px solid #d9dee4;
            border-top: 9px solid transparent;
        }
        &:hover {
        .toggle-icon {
            right: 3px;
        }
        .shape {
            border-left-width: 20px;
        }
    }
    }
}

</style>